module.exports = __webpack_public_path__ + "static/img_2064-fb4cae7cbf4856f9d5922815bae9e07e.webp";